import React from "react";

export default function Footer() {
	return (
		<div>
			<div className="container">
				<footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
					<span className="text-muted mx-auto">© 2022 Sayak Dutta</span>
				</footer>
			</div>
		</div>
	);
}
